import alert from 'config/alert'
import SessionContext from 'context/SessionContext'
import { Link } from 'react-router-dom'
import React, { useContext, useState } from 'react'
import { Button, Form, Grid, Header, Segment, Icon } from 'semantic-ui-react'
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import Page from './Page'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const session = useContext(SessionContext)
  const [fpHash, setFpHash] = React.useState('');

  React.useEffect(() => {
    const setFp = async () => {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();

      setFpHash(visitorId);

    };

    setFp();
  }, []);

  function login() {
    setLoading(true)
    session.login({
      email,
      password,
      deviceFingerPrint: fpHash,
      onError: error => {
        setLoading(false)
        alert.error(error.message)
      },
    })
  }

  const loginStyles = {
    container: {
      minHeight: '100vh',
      background: '#f3f4f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    },
    card: {
      background: 'white',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      padding: '40px',
      maxWidth: '450px',
      width: '100%',
      animation: 'fadeInUp 0.6s ease-out'
    },
    header: {
      marginBottom: '30px',
      textAlign: 'center'
    },
    title: {
      fontSize: '2.5em',
      fontWeight: 700,
      color: '#1f2937',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      width: '100%',
      textAlign: 'center'
    },
    subtitle: {
      color: '#6b7280',
      fontSize: '1em',
      fontWeight: 400,
      marginTop: '8px'
    },
    inputWrapper: {
      marginBottom: '20px'
    },
    button: {
      background: '#3867d6',
      border: 'none',
      borderRadius: '12px',
      padding: '16px',
      fontSize: '1.1em',
      fontWeight: 600,
      color: 'white',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
      marginTop: '10px'
    },
    buttonHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)'
    }
  }

  // Agregar estilos CSS personalizados
  React.useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .login-form-input input {
        border-radius: 12px !important;
        border: 2px solid #e5e7eb !important;
        padding: 14px 16px !important;
        font-size: 1em !important;
        transition: all 0.3s ease !important;
        background-color: #f9fafb !important;
      }
      .login-form-input.password-input input {
        padding-right: 50px !important;
      }
      .login-form-input input:focus {
        border-color: #667eea !important;
        background-color: white !important;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1) !important;
        outline: none !important;
      }
      .login-form-input .icon {
        color: #667eea !important;
      }
      .login-button {
        background: #667eea !important;
        border: none !important;
        border-radius: 12px !important;
        padding: 16px !important;
        font-size: 1.1em !important;
        font-weight: 600 !important;
        color: white !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
      }
      .login-button:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5) !important;
        background: #5568d3 !important;
      }
      .login-button:active {
        transform: translateY(0) !important;
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  return (
    <Page>
      <div style={loginStyles.container}>
        <div style={loginStyles.card}>
          <div style={loginStyles.header}>
            <div style={loginStyles.title}>
              <Icon name="sign in" size="large" />
              Iniciar Sesión
            </div>
            <div style={loginStyles.subtitle}>
              Ingresa tus credenciales para continuar
            </div>
          </div>

          <Form size='large' loading={loading}>
            <div style={loginStyles.inputWrapper}>
              <Form.Input
                className="login-form-input"
                fluid
                icon='user'
                iconPosition='left'
                placeholder='Email'
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    login()
                  }
                }}
              />
            </div>

            <div style={loginStyles.inputWrapper}>
              <div style={{ position: 'relative' }}>
                <Form.Input
                  className="login-form-input password-input"
                  fluid
                  icon='lock'
                  iconPosition='left'
                  placeholder='Contraseña'
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyPress={e => {
                    if (e.key === 'Enter') {
                      login()
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#667eea',
                    zIndex: 10
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#5568d3'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#667eea'}
                >
                  <Icon name={showPassword ? 'eye slash' : 'eye'} />
                </button>
              </div>
            </div>

            <div style={{ textAlign: 'right', marginBottom: '20px' }}>
              <Link to="/forgot-password" className="forgot-link">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <Button
              className="login-button"
              fluid
              size='large'
              onClick={login}
              loading={loading}
            >
              <Icon name="sign in" />
              Ingresar
            </Button>
          </Form>
        </div>
      </div>
    </Page>
  )
}
